import * as aTypes from '../action-types'
import * as mTypes from '../mutation-types'
import api from '../../api'

/*
const sampleShare = {
  type: '表单',
  link: 'http://lxi.me/w9b6o',
  name: '羊宝宝和小兔兔的展览筹款',
  qrcodeSrc: 'http://www.qrcode.com/en/img/codeIndex/qrcodeModelImage.png',
  by: '二十一世纪发展中心'
}
*/

const state = {
  type: '',
  link: '',
  name: '',
  qrcodeSrc: '',
  by: ''
}

const actions = {
  [aTypes.GET_SHARE] ({ commit, dispatch }, { formId, projectId, activityId }) {
    if (formId) {
      commit(mTypes.SET_LOADING, { key: aTypes.GET_SHARE, loading: true })
      api.form.getShare({
        success (res) {
          const body = res.body
          const share = {
            type: '表单',
            link: body.short_url,
            name: body.title,
            qrcodeSrc: `/api/qrcode/render?link=${body.short_url}`,
            by: body.team.name
          }
          commit(mTypes.SET_SHARE, share)
          commit(mTypes.SET_NAV_TITLE, body.title)
          commit(mTypes.SET_LOADING, { key: aTypes.GET_SHARE, loading: false })
          dispatch(aTypes.ZHUGE_TRACK, { event: '到达表单分享二维码页', data: { '表单名称': body.title }})
        },
        commit
      }, formId)
    } else if (projectId) {
      commit(mTypes.SET_LOADING, { key: aTypes.GET_SHARE, loading: true })
      api.cf.getShare({
        success (res) {
          const body = res.body
          const share = {
            type: '筹款',
            link: body.short_url,
            name: body.title,
            qrcodeSrc: `/api/qrcode/render?link=${body.short_url}`,
            by: body.team.name
          }
          commit(mTypes.SET_SHARE, share)
          commit(mTypes.SET_NAV_TITLE, body.title)
          commit(mTypes.SET_LOADING, { key: aTypes.GET_SHARE, loading: false })
          dispatch(aTypes.ZHUGE_TRACK, { event: '到达筹款分享二维码页', data: { '筹款名称': body.title }})
        },
        commit
      }, projectId)
    } else if (activityId) {
      commit(mTypes.SET_LOADING, { key: aTypes.GET_SHARE, loading: true })
      api.activity.getShare({
        success (res) {
          const body = res.body
          const share = {
            type: '活动',
            link: body.short_url,
            name: body.title,
            qrcodeSrc: `/api/qrcode/render?link=${body.short_url}`,
            by: body.team.name
          }
          commit(mTypes.SET_SHARE, share)
          commit(mTypes.SET_NAV_TITLE, body.title)
          commit(mTypes.SET_LOADING, { key: aTypes.GET_SHARE, loading: false })
          dispatch(aTypes.ZHUGE_TRACK, { event: '到达活动分享二维码页', data: { '活动名称': body.title }})
        },
        commit
      }, activityId)
    }
  }
}

const mutations = {
  [mTypes.SET_SHARE] (state, share) {
    state.type = share.type
    state.link = share.link
    state.name = share.name
    state.qrcodeSrc = share.qrcodeSrc
    state.by = share.by
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/share.js